import React, { Fragment } from "react";
import { BF_ROOT } from "../api-config";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {
  ShowController,
  Button,
  Link,
  Filter,
  TextInput,
  List,
  NumberField,
  Datagrid,
  TextField,
  Pagination,
  DateField,
  ReferenceManyField,
  Toolbar,
  ExportButton,
  ReferenceInput,
  ReferenceField,
  SelectInput,
  FunctionField,
  Edit,
  SimpleForm,
  EditButton,
} from "react-admin";

import { propEq, find, prop } from "ramda";
import { TextBooleanField } from "../components/TextBooleanField";
import styled from "styled-components";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AddIcon from "@material-ui/icons/Add";
import CreateIcon from "@material-ui/icons/Create";
import { getPermissionRole } from "../util";

const tourType = [
  { _tour_category_id: "1", description: "IMT Tours" },
  { _tour_category_id: "2", description: "IMT Custom Tours" },
  { _tour_category_id: "3", description: "Globals Tours" },
];

const StyledDiv = styled.div((props) => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px",
}));

const StyledA = styled.a`
  color: #ff9a00;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
`;

const StyledGrid = styled(Grid)`
  text-align: center;
`;

const StyledToolbar = styled(Toolbar)`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  background-color: #ffffff !important;
`;

const languages = ["en", "pt", "de", "es"];

const priceTypes = [
  { _id: "tour_total", desc: "tour_total", description: "Base Price" },
  { _id: "tour_passenger", desc: "tour_passenger", description: "Passenger" },
  { _id: "tour_single", desc: "tour_single", description: "Single Room" },
  { _id: "tour_base_model", desc: "tour_base_model", description: "Base Model" },
  { _id: "tour_vehicle", desc: "tour_vehicle", description: "Tour Vehicle" },
  { _id: "tour_cat_2", desc: "tour_cat_2", description: "Cat 2" },
  { _id: "tour_cat_4", desc: "tour_cat_4", description: "Cat 4" },
  { _id: "tour_cat_6", desc: "tour_cat_6", description: "Cat 6" },
  { _id: "tour_cat_8", desc: "tour_cat_8", description: "Cat 8" },
  { _id: "tour_cat_10", desc: "tour_cat_10", description: "Cat 10" },
  { _id: "tour_cat_12", desc: "tour_cat_12", description: "Cat 12" },
  { _id: "tour_cat_14", desc: "tour_cat_14", description: "Cat 14" },
  // { _id: "tour_f700_up", desc: "tour_f700_up", description: "F700" },
  // { _id: "tour_f_up", desc: "tour_f_up", description: "F Upgrade" },
  // { _id: "tour_st_up", desc: "tour_st_up", description: "ST Upgrade" },
  // { _id: "tour_gs_up", desc: "tour_gs_up", description: "GS Upgrade" },
  // { _id: "tour_rt_up", desc: "tour_rt_up", description: "RT Upgrade" },
  // { _id: "tour_gt_up", desc: "tour_gt_up", description: "GT Upgrade" },
  // { _id: "tour_gsa_up", desc: "tour_gsa_up", description: "GSA Upgrade" },
  // { _id: "tour_f6_up", desc: "tour_f6_up", description: "F6 Upgrade (OLD - Not mandatory)"},  
];


const TourPricePagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);
const TourPricesPagination = (props) => (
  <Pagination perPage={10} rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const TourPriceFilter = (props) => (
  <Filter {...props} style={{ flexWrap: "unset" }}>
    <TextInput label="Search" source="q" alwaysOn />
    <SelectInput
      allowEmpty={true}
      label="Tour Type"
      source="tour_category_id"
      choices={tourType}
      optionText="description"
      optionValue="_tour_category_id"
      alwaysOn
    />
  </Filter>
);

const TourPriceListToolbar = (props) => (
  <StyledToolbar {...props}>
    <Button
      component={Link}
      to={{
        pathname: `/tours/create`,
      }}
      label="Create"
    >
      <AddIcon />
    </Button>
  </StyledToolbar>
);

const TourPriceEditToolbar = (props) => (
  <Toolbar {...props}>
    <Button
      component={Link}
      to={{
        pathname: `/tour_prices`,
      }}
      label="Back to Tour List"
    >
      <ArrowBackIcon />
    </Button>
    {([1, 2, 4, 6, 9].includes(getPermissionRole()) &&
      <React.Fragment>
        <Button
          component={Link}
          to={{
            pathname: "/pricest/create",
            search: `?price_item_id=${props.record.id}&price_item_type=tour`,
          }}
          label="Add tour Price"
        >
          <AddIcon />
        </Button>
        <Button
          component={Link}
          to={{
            pathname: `/tours/${props.record.id}`,
          }}
          label="Edit tour"
        >
          <CreateIcon />
        </Button>        
      </React.Fragment>
    )}

  </Toolbar>
);

// const tourCats = [
//   { _id: 1, description: 'Imt Tours' },
//   { _id: 2, description: 'Imt Custom Tours' },
//   { _id: 3, description: 'Globals Tours' },
// ];

const CustomEditTourButton = ({ record = {} }) => {
  return <EditButton basePath="tours" record={record} label="Edit Tour" />;
};

const CustomEditTourPricesButton = ({ record = {} }) => {
  return (
    <EditButton
      basePath="tour_prices"
      record={record}
      label="Edit Tour Prices"
    />
  );
};

const CustomEditTourPriceButton = ({ record = {} }) => {
  return (
    <EditButton
      component={Link}
      to={{
        pathname: `/pricest/${record.id}`,
        search: `?tour_id=${record.price_item_id}`,
      }}
      label="Edit"
    />
  );
};

export const TourPriceList = (props) => (
  <List
    {...props}
    resource="tour_prices"
    pagination={<TourPricePagination />}
    actions={<TourPriceListToolbar />}
    bulkActionButtons={false}
    filters={<TourPriceFilter />}
    title="Tour List and Prices"
    sort={{ field: "tour_start_date", order: "DESC" }}
  >
    <Datagrid
      // toolbar={<TourPriceListToolbar />}
      rowClick="expand"
      expand={<InfoShow />}
    >
      <TextField label="Tour ID" source="id" />
      <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} label="Start Date" source="tour_start_date" />
      <ReferenceField
        label="Tour Name"
        source="tour_name_id"
        reference="tour_names"
        linkType={false}
      >
        <TextField source="tour_name_en" />
      </ReferenceField>

      <FunctionField
        label="Base"
        addLabel={false}
        render={(tour) => {
          return (
            <StyledDiv color={tour.location_1.color}>
              {tour.location_1.location_name}
            </StyledDiv>
          );
        }}
      />
      <FunctionField
        label="Destination"
        addLabel={false}
        render={(tour) => {
          return (
            <StyledDiv color={tour.location_2.color}>
              {tour.location_2.location_name}
            </StyledDiv>
          );
        }}
      />

      <TextBooleanField label="Status" source="tour_status" />
      {([1, 2, 4, 6, 9].includes(getPermissionRole()) && <CustomEditTourButton />)}
      {([1, 2, 4, 6, 9].includes(getPermissionRole()) && <CustomEditTourPricesButton />)}
    </Datagrid>
  </List>
);

const TourPriceEditTitle = (object) => (
  <span>
    {" Edit Prices for Tour - "} {object.record.id}
  </span>
);

const InfoShow = (props) => (
  <ShowController {...props} title=" ">
    {({ record }) =>
      record && (
        <Card style={{ width: "100%", margin: "auto" }}>
          <CardContent>
            <Grid container spacing={16}>
              <StyledGrid item xs={12}>
                <Typography variant="subheading" gutterBottom align="center">
                  <br /> Tour link ({record.id}):{" "}
                  {languages.map((l) => {
                    return (
                      <p>
                        <b>
                          {l.toUpperCase()} - {BF_ROOT}/tour_booking?tourUid=
                          {record.tour_uid}
                          &locale={l}
                        </b>
                        <br />
                        <StyledA
                          target="_blank"
                          href={`${BF_ROOT}/tour_booking?tourUid=${record.tour_uid}&locale=${l}`}
                        >
                          Direct link to Client {l.toUpperCase()}
                        </StyledA>
                      </p>
                    );
                  })}
                </Typography>

                <Typography variant="subheading" gutterBottom align="center">
                  <br /> Tour link P4M ({record.id}):{" "}
                  {languages.map((l) => {
                    return (
                      <p>
                        <b>
                          {l.toUpperCase()} - {BF_ROOT}/tour_booking?tourUid=
                          {record.tour_uid}
                          &p4m=1&locale={l}
                        </b>
                        <br />
                        <StyledA
                          target="_blank"
                          href={`${BF_ROOT}/tour_booking?tourUid=${record.tour_uid}&p4m=1&locale=${l}`}
                        >
                          Direct link to P4M Client {l.toUpperCase()}
                        </StyledA>
                      </p>
                    );
                  })}
                </Typography>
              </StyledGrid>
            </Grid>
          </CardContent>
        </Card>
      )
    }
  </ShowController>
);

export const TourPriceEdit = (props) => (
  <Edit title={<TourPriceEditTitle />} {...props}>
    <SimpleForm toolbar={<TourPriceEditToolbar props={{ ...props }} />}>
      <ReferenceInput
        label="Tour Name"
        source="tour_name_id"
        reference="tour_names"
        sort={{ field: "tour_name_en", order: "ASC" }}
      >
        <SelectInput source="id" optionText="tour_name_en" disabled={true} />
      </ReferenceInput>
      <ReferenceManyField
        pagination={<TourPricesPagination />}
        perPage={10}
        addLabel={false}
        reference="prices"
        target="price_item_id"
        filter={{ price_item_type: "tour", order_by_property: true }}
        sort={{ field: "start_date", order: "DESC" }}
      >
        <Datagrid>
          <TextField label="Price ID" source="id" />
          <FunctionField
            sortable={false}
            label="Item Type"
            addLabel={false}
            render={(item) => {
              const itemD = find(
                propEq("_id", item.price_item_sub_type),
                priceTypes
              );
              console.log(prop("description", itemD));
              return prop("description", itemD);
            }}
          />

          <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} source="start_date" />
          <NumberField
            source="price"
            options={{ style: "currency", currency: "EUR" }}
          />
          {( [1, 2, 4, 6, 9].includes(getPermissionRole()) &&
            <CustomEditTourPriceButton props={{ ...props }} />
          )}
          
        </Datagrid>
      </ReferenceManyField>
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/resources/tourPrices.js